import create from 'zustand'

type Status = 'waiting' | 'success' | 'fail'

type State = {
  audio: boolean
  video: boolean
  screen: boolean
  webcamAccess: boolean
  audioAccess: boolean
  videoWidth: number
  videoHeight: number
  status: Status
  errorMedia: string
  small: boolean
  setAudio: (data: boolean) => void
  setVideo: (data: boolean) => void
  setScreen: (data: boolean) => void
  setWebcamAccess: (data: boolean) => void
  setAudioAccess: (data: boolean) => void
  setVideoWidth: (data: number) => void
  setVideoHeight: (data: number) => void
  setStatus: (data: Status) => void
  setErrorMedia: (data: string) => void
  setSmall: (data: boolean) => void
}

export const useVideoStore = create<State>(set => ({
  audio: true,
  video: true,
  screen: false,
  webcamAccess: false,
  audioAccess: false,
  videoWidth: 1600,
  videoHeight: 1200,
  status: 'waiting',
  errorMedia: '',
  small: false,
  setAudio: (data: boolean) => set({ audio: data }),
  setVideo: (data: boolean) => set({ video: data }),
  setScreen: (data: boolean) => set({ screen: data }),
  setWebcamAccess: (data: boolean) => set({ webcamAccess: data }),
  setAudioAccess: (data: boolean) => set({ audioAccess: data }),
  setVideoWidth: (data: number) => set({ videoWidth: data }),
  setVideoHeight: (data: number) => set({ videoHeight: data }),
  setStatus: (data: Status) => set({ status: data }),
  setErrorMedia: (data: string) => set({ errorMedia: data }),
  setSmall: (data: boolean) => set({ small: data }),
}))
